import { createContext } from "react";
export const UIContext = createContext({
  //   onBoarding: false,
  //   setOnBoarding: () => {},
});
